import useUser from '@/hooks/useUser';
import EditSolid from '@simplywallst/ui-core/icons/EditSolid';

import { EditNarrativeLink } from './styled';

type Props = {
  authorId: string;
  id: string;
};

export const EditNarrative = ({ authorId, id }: Props) => {
  const { data: user, queryStatus } = useUser();

  if (queryStatus === 'pending' || queryStatus === 'error') {
    return null;
  }

  if (!user.loggedIn || user.id !== authorId) {
    return null;
  }

  return (
    <EditNarrativeLink
      to={`/narratives/edit/${id}`}
      alignIcon="left"
      styleType="loud"
    >
      <EditSolid />
      Edit
    </EditNarrativeLink>
  );
};
